import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { DataUtilService } from './data-util.service';
import { TokenStorageService } from './token-storage.service';
import { AuthService } from './auth.service';



@Injectable({
  providedIn: 'root'
})
export class MessageService {
  aHeader = undefined

  constructor(
    private http: HttpClient,
    private dataUtilService:DataUtilService,private tss:AuthService) { }

  getMessages(userId:number) {
    return this.http.get<any>(`${environment.apiUrl}/message/angularMessages/${userId}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }
  getMessageById(messageId:number) {
    return this.http.get<any>(`${environment.apiUrl}/message/angularshow/${messageId}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }
  getToUserOptions(userId:number) {
    return this.http.get<any>(`${environment.apiUrl}/message/angulartouseroptions/${userId}`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }
    ))
  }
  sendMessage(formData: string) {
    return this.http.post(`${environment.apiUrl}/message/angularsave`, formData, this.aHeader.bearerFormHeaders)
      .pipe(map(data => {
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }

      }));
  }
}
